import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { setFoodsList } from '../../../../store/foodsSlice';
import Loader from '../../../BaseComponents/Loader';
import TableSkeleton from '../../../BaseComponents/TableSkeleton';
import './FoodsTable.scss';
import {  getFoodList } from '../../../../api/food';
import TableHeader from '../../../BaseComponents/TableHeader';
import FoodsTableMedicalLibraryRow from './FoodsTableMedicalLibraryRow';
import { Food } from '../../../../types/apiGeneratedTypes';
import { toast } from 'react-toastify';

const headerColumns = [
  { title: 'Image', key: 'image', minWidth: '100px', flex: 0 },
  { title: 'Name', key: 'name', minWidth: '250px', flex: 0, sortable: true, apiKey: "name" },
  { title: 'Description', key: 'description', minWidth: '250px', flex: 1 },
  { title: '', key: 'actions', minWidth: '50px', flex: 0 },
];

const FoodsTableMedicalLibrary: React.FC = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [sortingLoading, setSortingLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<any>(null);
  const { foodsList } = useSelector(
    (state: RootState) => state.foods
  );
  const [sortedFoods, setSortedFoods] = React.useState<any>(foodsList);

  const fetchFoods = useCallback(async (search?: string) => {
      try {
        setLoading(true);
        const foodsListResp = await getFoodList(search);
        dispatch(setFoodsList(foodsListResp));
        // Reset sorted foods when fetching new data
        setSortedFoods(null);
      } catch (error) {
        console.error(error);
        setError(error);
      } finally {
        setLoading(false);
      }
    }, [dispatch]);

  const onSort = async (columnKey: string, direction: 'asc' | 'desc') => {
    try {
      setSortingLoading(true);
      const newFoodsList = await getFoodList('', columnKey, direction);
      setSortedFoods(newFoodsList);
    } catch (err) {
      console.error('Error sorting foods:', err);
      toast.error('Failed to sort foods. Please try again.');
    } finally {
      setSortingLoading(false);
    }
  };

  useEffect(() => {
    fetchFoods();
  }, [fetchFoods]);

  if (loading) return <Loader />;
  if (error) return <div>Error loading foods...</div>;

  const displayFoods = sortedFoods ? sortedFoods : foodsList;

  return (
    <div className='scroll-container'>
      <div className='table-container foods-table'>
        <TableHeader headerColumns={headerColumns} gap={'24px'} onSort={onSort} />
        <div className='table-body'>
          {sortingLoading ? (
            <TableSkeleton rows={5} columns={4} />
          ) : (
            displayFoods?.foods?.map((food: Food, index: number) => (
              <FoodsTableMedicalLibraryRow
                key={`${food.id}`}
                foodData={food}
                foodsList={displayFoods?.foods}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};
export default FoodsTableMedicalLibrary;
